module.exports = __webpack_public_path__ + "img/卧室空间.3ef8d3d5.webp";